
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TooltipIcon',
  props: {
    text: {
      type: String,
      required: true
    }
  }
})
